import Icon from "@lib/common/components/Icon/Icon";
import { Box, Center, Loader, Stack, Text, Title, Transition } from "@mantine/core";
import { useEffect, useState } from "react";

const backgroundTransition = {
  in: { opacity: 0.4, transform: "scale(1.2)" },
  out: { opacity: 0, transform: "scale(0.5)" },
  common: { transformOrigin: "center" },
  transitionProperty: "transform, opacity"
};

export const AppLoader = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <Center h="100vh" bg={"var(--mantine-color-default)"}>
      <Transition mounted={fadeIn} transition={backgroundTransition} duration={2000}>
        {styles => (
          <Box pos="absolute" style={{ ...styles, zIndex: 0 }}>
            <Icon name="radar" variant="thin" color={"var(--mantine-color-default-hover)"} size="40vw" />
          </Box>
        )}
      </Transition>
      <Stack align="center" gap="md" mt="-10vh" style={{ zIndex: 1 }}>
        <Loader size="lg" color="var(--mantine-primary-color-filled)" />
        <Title order={1}>Loading SDLabs</Title>
        <Text c={"dimmed"}>One moment please</Text>
      </Stack>
    </Center>
  );
};
